// removed by extract-text-webpack-plugin
module.exports = {"textParagraph":"undefined","unit":"5px","oldColorYellow":"#ffce34","oldColorOrange":"#cc4e00","oldColorBlue":"#027db6","oldColorGreen":"darkgreen","oldColorRed":"#b71c1c","oldColorWhite":"#ffffff","loader":"loader__loader____2pe4S","withOverlay":"loader__withOverlay____2l7v9","circular":"loader__circular____2-rOs","rotate":"loader__rotate____TPLgB","path":"loader__path____UtrJE","dash":"loader__dash____37t1k","color":"loader__color____3s8yE","errorText":"loader__errorText____27xxQ undefined"};


//////////////////
// WEBPACK FOOTER
// ./src/loader/loader.css
// module id = 251
// module chunks = 0